import { ERoomType } from '../types/rooms';
const ROOM_TYPE_FILTERS = ['room1', 'room2', 'room3', 'room4', 'room5', 'room6', 'room7', 'room9'];
const ROOM_TYPE_FILTERS_MAP = {
  room1: ERoomType.OneRoom,
  room2: ERoomType.TwoRoom,
  room3: ERoomType.ThreeRoom,
  room4: ERoomType.FourRoom,
  room5: ERoomType.FiveRoom,
  room6: ERoomType.Large,
  room7: ERoomType.OpenPlan,
  room9: ERoomType.Studio
};
export const getFilterParams = isQueryParamsEnabled => {
  if (typeof window === 'undefined' || !isQueryParamsEnabled) {
    return {
      roomTypes: []
    };
  }
  const roomTypes = [];
  const searchParams = new URLSearchParams(window.location.search);
  for (const [key, value] of searchParams.entries()) {
    if (ROOM_TYPE_FILTERS.includes(key) && value === '1') {
      roomTypes.push(ROOM_TYPE_FILTERS_MAP[key]);
    }
  }
  return {
    roomTypes
  };
};
export const setRoomQueryParams = roomTypes => {
  if (typeof window === 'undefined') {
    return;
  }
  const searchParams = new URLSearchParams(window.location.search);
  for (const roomFilter of ROOM_TYPE_FILTERS) {
    const filter = ROOM_TYPE_FILTERS_MAP[roomFilter];
    if (roomTypes.includes(filter)) {
      searchParams.set(roomFilter, '1');
    } else {
      searchParams.delete(roomFilter);
    }
  }
  const url = "".concat(window.location.pathname, "?").concat(searchParams.toString());
  window.history.pushState(null, document.title, url);
};